import { TruckMaterialType } from "../../../../enums/truckMaterialType";

export const AddTicketFormConstants = {
  CUSTOMER_SELECT_NAME: "customerName",
  CUSTOMER_SELECT_LABEL: "Customer",
  JOB_SELECT_NAME: "jobName",
  JOB_SELECT_LABEL: "Job",
  ORDER_SELECT_NAME: "orderId",
  ORDER_SELECT_LABEL: "Order",
  QUARRY_SELECT_NAME: "quarryName",
  QUARRY_SELECT_LABEL: "Quarry",
  MATERIAL_SELECT_NAME: "materialName",
  MATERIAL_SELECT_LABEL: "Material",
  TRUCK_SELECT_NAME: "truckNumber",
  TRUCK_SELECT_LABEL: "Truck Number",
};

export const SELECT_PLACEHOLDER = "Select";
export const OPTION_FILTER_PROP = "label";

export const MiscellaneousConsts = {
  HOUR_KEY: "Hour",
  NA_KEY: "N/A",
};

export const orderDetailsHeaders = {
  pickupName: "Pickup",
  pickupAddress: "Pickup Address",
  dropoffAddress: "Dropoff Address",
  dropoffName: "Dropoff",
  truckTypes: "Approved Truck Types",
  minimumTruckingHours: "Trucking Minimum Hours",
  truckingRate: "Trucking Rate",
  materialRate: "Material Rate+Tax",
  landedRate: "Landed Rate",
  materialCost: "Quarry Cost",
  salesperson: "Salesperson Name",
  materialCategory: "Material Category",
  materialType: "Material Type",
  materialName: "Material Name",
};

export const getOrderDetailSummary = ({
  pickUpName,
  pickUpAddress,
  dropOffAddress,
  dropOffName,
  truckTypes,
  minimumTruckingHours,
  truckingRate,
  materialRate,
  materialCost,
  landedRate,
  salesperson,
  materialCategory,
  materialType,
  materialName,
  isMaterialJob,
}) => {
  return [
    [orderDetailsHeaders.pickupName, pickUpName],
    [orderDetailsHeaders.pickupAddress, pickUpAddress],
    [orderDetailsHeaders.dropoffAddress, dropOffAddress],
    [orderDetailsHeaders.dropoffName, dropOffName],
    [orderDetailsHeaders.truckTypes, truckTypes],
    [orderDetailsHeaders.minimumTruckingHours, minimumTruckingHours],
    [orderDetailsHeaders.truckingRate, truckingRate],
    [orderDetailsHeaders.materialRate, materialRate],
    [orderDetailsHeaders.landedRate, landedRate],
    [orderDetailsHeaders.materialCost, materialCost],
    [orderDetailsHeaders.salesperson, salesperson],
    [
      orderDetailsHeaders.materialCategory,
      isMaterialJob ? materialCategory : "-",
    ],
    [orderDetailsHeaders.materialType, isMaterialJob ? materialType : "-"],
    [orderDetailsHeaders.materialName, materialName],
  ];
};

export const getTruckNumbersOptions = (data) =>
  buildUniqueOptions(
    data,
    (r) => r?.truckId,
    (r) => r?.truckId,
    (r) => r?.truckId,
  );

export const getMaterialOptions = (data) =>
  buildUniqueOptions(
    data,
    (r) => r?.materialId,
    (r) => r?.label,
    (r) => r?.value,
  );

export const getVendorOptions = (data) =>
  buildUniqueOptions(
    data,
    (r) => r?.vendorId,
    (r) => r?.vendor,
    (r) => r?.vendorId,
  );

export const getJobOptions = (data) =>
  buildUniqueOptions(
    data,
    (r) => r?.jobId,
    (r) => r?.displayName,
    (r) => r?.jobId,
  );

export const getCustomersOptions = (data) =>
  buildUniqueOptions(
    data,
    (r) => r?.companyId,
    (r) => r?.companyName,
    (r) => r?.companyId,
  );

export const getOrdersOptions = (data) =>
  buildUniqueOptions(
    data,
    (r) => r?.order?.id,
    (r) => r?.orderNumber,
    (r) => r?.order?.id,
  );

export const buildUniqueOptions = (
  data,
  keyExtractor,
  labelExtractor,
  valueExtractor,
) => {
  const seen = new Set();
  return data
    ?.filter((record) => {
      const key = keyExtractor(record);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((record) => ({
      label: labelExtractor(record),
      value: valueExtractor(record),
      key: keyExtractor(record),
    }));
};

export const addTicketConstantStatus = {
  uploadReviewStatus: "Review",
  submissionReviewStatus: "Closed",
  ticketVerificationStatus: "Open",
};

export const ticketUploadDefaultValue = {
  customerName: undefined,
  jobName: undefined,
  materialName: undefined,
  quarryName: undefined,
  orderId: undefined,
  truckNumber: undefined,
};
